import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const TickerRBAC = {
  pageID: 'db5358f96a3c64bf6dc55cd2a7cd194b',
  elementID: {
    View: '447d8e393a8ba6116986b21a004ef94c',
    Edit: '6995d265a4fddc3b0babab4531a1c161',
    Create: 'ee1efa6686a202b2b88adb32545e40b5',
    Delete: '58ffc0ffb36a6b4a49eb8cf8e27d8260',
    ToggleStatus: '28fa673099bf85fbf6aecfb6893d908f',
  },
} as const

export const useRBACTickerPage = createUseRBAC(TickerRBAC.elementID)

export type UseRBACTickerPagePageType = ReturnType<typeof useRBACTickerPage>
